import * as React from 'react';
import {FC} from 'react';
import ElementComponent from './ElementComponent';
import {ElementLogic} from './types';

interface ListComponentProps {
  data?: ElementLogic[],
  index?: number,
  parent: string,
}

const ListComponent: FC<ListComponentProps> = ({data, parent, index}) => {
  if (!Array.isArray(data)) {
    return null;
  }

  return (
    <React.Fragment>
      {data.map((el: ElementLogic, i: number) => {
        const uniqueID = [
          ...(parent ? [parent] : []),
          ...(el?.name ? [el.name] : []),
          ...(i ? [i] : [])
        ].join('.');

        return (
          <ElementComponent
            key={uniqueID}
            index={index}
            element={el}
            parent={parent}
          />
        );
      })}
    </React.Fragment>
  )
};

const MemoizedListComponent = React.memo(
  ListComponent,
  (prevProps, nextProps) =>
    Array.isArray(prevProps.data) === Array.isArray(nextProps.data)
    && prevProps.parent === nextProps.parent
);

export default MemoizedListComponent;
